import React, { StatelessComponent } from 'react';
import { Illustration } from '../illustrations/illustration';
import FR from '!svg-url-loader?noquotes=true!grpn-mx-mixer/dist/images/flags/france.svg';
import NL from '!svg-url-loader?noquotes=true!grpn-mx-mixer/dist/images/flags/netherlands.svg';
import GB from '!svg-url-loader?noquotes=true!grpn-mx-mixer/dist/images/flags/great-britain.svg';

const flagsMapper = {
  FR,
  NL,
  GB,
};

export interface FlagProps {
  size: number;
  country: 'FR' | 'NL' | 'GB';
}

export type FlagComponent = StatelessComponent<FlagProps>;

export const Flag: FlagComponent = ({ country, size }) => (
  <Illustration src={flagsMapper[country]} widht={size} height={size} />
);
